import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import { getLocaleString } from "lib/localization/vendor";
import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from "ol/style";

export default function StyleAnnotationArrowFeature(feature:Feature<Geometry>, selected:boolean = false) {
	const colorHex:string = selected ? 'blue' : (feature.get('Color') || _config.currentAnnotationColor) ?? '#00ff00';
	const fontSize:number = Number(feature.get('FontSize')) || 14;
	
	const styles:Style[] = [];
	
	(feature.getGeometry() as LineString).forEachSegment((start:any, end:any) => {
		const dx = end[0] - start[0];
		const dy = end[1] - start[1];
		const rotation = Math.atan2(dy, dx);
		
		const arrowArmLength:number = 5;
		
		var lineStr1 = new LineString([end, [end[0] - arrowArmLength, end[1] + arrowArmLength]]);
		lineStr1.rotate(rotation, end);
		
		var lineStr2 = new LineString([end, [end[0] - arrowArmLength, end[1] - arrowArmLength]]);
		lineStr2.rotate(rotation, end);
		
		var stroke = new Stroke({
			color: colorHex,
			width: 3,
			lineDash: selected ? [5, 5] : undefined,
		});
		
		styles.push(new Style({
			geometry: lineStr1,
			stroke: stroke
		}));
		styles.push(new Style({
			geometry: lineStr2,
			stroke: stroke
		}));
	});
	
	return styles;
}